import classes from '@/App.module.scss';
import ImportFilesTable from '@/components/ImportFiles/ImportFiles';
import { ContentSkeleton } from '@/components/LoadingSkeleton/LoadingSkeleton';

import { Suspense } from 'react';

export default function PageImportFiles() {
  return (
    <div className={classes.reportsPage}>
      <div className={classes.reportTable}>
        <Suspense
          fallback={<ContentSkeleton />}
        >
          <ImportFilesTable />
        </Suspense>
      </div>
    </div>
  );
}

